import { Tooltip } from "@mui/material";
import { useMemo } from "react";
import { LuMoon, LuSun } from "react-icons/lu";
import { useColorMode } from "../../theme/ThemeProviderWrapper";

const ThemeButton = () => {
  const { mode, toggleColorMode } = useColorMode();
  const isDarkMode = useMemo(() => mode === "dark", [mode]);
  const isLightMode = useMemo(() => mode === "light", [mode]);
  
  const label = useMemo(() => {
    if (isDarkMode) return "Switch to light mode";
    if (isLightMode) return "Switch to dark mode";
    return "Toggle theme mode";
  }, [isDarkMode, isLightMode]);

  return (
    <Tooltip title={label}>
      <button 
        onClick={toggleColorMode} 
        className="footer-pill-btn"
      >
        {isLightMode && <LuSun size={18} />}
        {isDarkMode && <LuMoon size={18} />}
      </button>
    </Tooltip>
  );
};

export default ThemeButton;

